import Book from '../../images/mysterious_book.png';

export default function IwoLaura() {
	return (
		<div className="flex flex-col gap-3">
			<p className="text-3xl text-center font-bold mb-3">
				A teraz edukacja, ale nie do życia w rodzinie, ani BHP, a... po prostu
				edukacja XD
			</p>
			<div className="relative w-[40%] mx-auto">
				<img
					src={Book}
					alt="parachute"
					className="rounded-lg shadow-lg shadow-orange-400/50 object-cover"
				/>
				<div className="absolute right-5 top-5 bg-orange-600 text-white font-bold uppercase rounded-lg px-3 py-1">
					do zrealizowania w EMPIKu
				</div>
			</div>

			<i className="text-2xl text-orange-600 text-center font-bold my-4">
				Na wybraną przez siebie książkę, wartość bonu (około): 50 zł
			</i>
		</div>
	);
}
